const getWebpSupport = () => {
  if (typeof window === 'object') {
    const elem = document.createElement('canvas');

    if (elem.getContext && elem.getContext('2d')) {
      // was able or not to get WebP representation
      return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
    }

    // very old browser like IE 8, canvas not supported
    return false;
  }
};

const isWebpSupported = getWebpSupport();

function generateImageURL(src: string) {
  if (isWebpSupported) {
    const separator = src.includes('?') ? '&' : '?';
    return `${src}${separator}type=webp`;
  }

  return src;
}

export default generateImageURL;
